export default {
  buttons: {
    add: 'Adaugă',
  },
  AddOn: {
    label: 'Add-on',
    title: 'Obțineți aplicația mobilă',
    subscribed: 'Abonat',
    cta: 'Obțineți aplicația mobilă',
    price_per_month: '{{price}} / lună',
    tax_included: 'taxele aplicabile incluse',
    apple_developer_note:
      'Necesită un cont Apple Developer (99 USD/an, plătit către Apple) pe entitatea legală a restaurantului.',
    features: {
      stores: 'Listată pe App Store și Google Play',
      push: 'Notificări push pentru clienții tăi',
      loyalty: 'Puncte de fidelitate și recompense',
      commission: 'Comenzi directe cu 0% comision',
    },
  },
};
